import * as ActionTypes from "../constants/ActionTypes";

// **************************************************************************************************************
export const toggleSelectionReducer = (state = {}, action) => {

    switch (action.type) {

        case ActionTypes.TOGGLE_SELECTION_TRIGGERED:

            return Object.assign({}, state, {[action.selectionId]: action.selectedContentId})

        default:
            return state

    }

}



/** WEBPACK FOOTER **
 ** ./src/reducers/ToggleSelections.js
 **/